function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 44 44",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M23.901,24.386l16.265,0.001c1,0 1.813,-0.809 1.813,-1.808c0,-1.005 -0.812,-1.808 -1.813,-1.808l-16.265,-0.001l-0.001,-16.265c0,-1 -0.81,-1.812 -1.808,-1.812c-1.005,0 -1.808,0.811 -1.808,1.812l0.001,16.265l-16.265,-0.001c-1,0 -1.813,0.81 -1.813,1.808c0.001,1.005 0.812,1.808 1.813,1.808l16.265,0.001l0.001,16.265c0,1 0.81,1.813 1.808,1.813c1.006,0 1.808,-0.812 1.808,-1.812l-0.001,-16.266Z",
    style: {
      stroke: "#000",
      strokeWidth: "1.5px"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/add.a05e8e5722e6f7c94f8ff23b4875685f.svg";
export { ForwardRef as ReactComponent };